import React from "react"
import styles from "./Loader.module.scss"
import logoGif from "../../../assets/loaders/logo_gif.gif"

const Loader: React.FC = () => (
  <div className={styles.Loader} data-testid="Loader">
    <img src={logoGif} alt="" width="100px" />
  </div>
)

export default Loader
